import React from 'react'
import { Link } from 'react-router'
import { Container, Row, Col, Button, InputGroup, InputGroupAddon, Input, Label, FormGroup } from 'reactstrap';

import StatusChoices from './StatusChoices'

class FirstStatusChoices extends React.Component {

	constructor(props) {
	  super(props);
	  this.state = {
	  	choice:null
	  }
	}

	validChoice(){
		if(this.state.choice)
			this.props.onChangeChoices(this.state.choice)
	}

	render(){
		const { provider } = this.props

		return(
			<div className="background-white">
                  <div className="login-page status-page">
                    
                        <Row>
                            <Col>
                                <div className="bloc-right center close" onClick={() => this.props.onClose()}>X</div>
                            </Col>
                        </Row>

                        <div className="login-container">
                            <Row>
                                <Col>
                                    <div className="login-title">Statut de candidature</div>
                                    <div className="login-company"> <Link to={"/manager/prestataire/"+provider.id}>{provider.company}</Link> </div>
                                </Col>
                            </Row>

                            <div className="bloc-login">

				                        <FormGroup check>
								            <Label check>
								              <Input type="radio" name="radio1" onChange={() => this.setState({choice:"A"})} />{' '}
								              Acceptée
								            </Label>
							           </FormGroup>

							           <FormGroup check>
								            <Label check>
								              <Input type="radio" name="radio1" onChange={() =>  this.setState({choice:"W"})} />{' '}
								              Stand-by
								            </Label>
							           </FormGroup>

							           <FormGroup check>
								            <Label check>
								              <Input type="radio" name="radio1" onChange={() =>  this.setState({choice:"R"})} />{' '}
								              Refusée
								            </Label>
							           </FormGroup>
				                            
				                     <div className="center validate">
				                        <Button className="btn-green" onClick={() => this.validChoice()} >Valider</Button>
				                    </div>
				            </div>

                        </div>

                    
                  </div>
            </div>
		)
	}
}


export default FirstStatusChoices


// WEBPACK FOOTER //
// ./src/provider/components/status/FirstStatusChoices.js